import { Colors } from '@sigma-frontend-libs/commons'

import render from './render'

export default {
  name: 'Preloader',

  props: {
    size: {
      type: Number,
      default: 24
    },

    count: {
      type: Number,
      default: 3
    },

    color: {
      type: String,
      default: Colors.description,
      validator: value => {
        return Object.values(Colors).includes(value)
      }
    },

    rainbow: {
      type: Boolean,
      default: false
    },

    duration: {
      type: Number,
      default: 500
    }
  },

  data() {
    return {
      index: 0,
      interval: undefined
    }
  },

  computed: {
    $class() {
      return {
        preloader: true,
        [`preloader--${this.color}`]: !!this.color && !this.rainbow,
        'preloader--rainbow': this.rainbow
      }
    },
    $style() {
      return {
        'grid-template-columns': `repeat(${this.count}, ${this.size}px)`,
        gap: `${this.size / 4}px`
      }
    },

    rainbowColors() {
      return [
        Colors.success,
        Colors.warning,
        Colors.error,
        Colors.primary,
        Colors.epic
      ]
    }
  },

  mounted() {
    this.interval = setInterval(() => {
      if (this.index === this.count - 1) {
        this.index = 0
      } else {
        this.index = this.index + 1
      }
    }, this.duration)
  },

  beforeDestroy() {
    clearInterval(this.interval)
  },

  render
}
